import {Component, Input, OnInit, Optional} from '@angular/core';
import {NgbActiveModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [
    CommonModule,
    NgbModule,
    TranslateModule
  ],
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

  @Input() title: string;
  @Input() message: string;
  @Input() type: string;

  constructor(
    @Optional() private activeModal: NgbActiveModal
  ) {
  }

  ngOnInit() {
  }

  close() {
    if (this.activeModal) {
      this.activeModal.close();
    }
  }
}
